import get from 'lodash/get';

import {
  asyncActionTypeFailure,
  asyncActionTypeRequest,
  asyncActionTypeSuccess,
} from 'views/AddProduct/types';
import types from './types';

const initialState = {
  desktopReviewFilters: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewJobs: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewAllJobs: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewPartners: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewJobDocuments: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewJob: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewJobTestPlans: {
    loading: false,
    data: {},
    error: '',
  },
  desktopReviewJobSummary: {
    loading: false,
    data: [],
    error: '',
  },
  suppliersList: {
    loading: false,
    data: {},
    error: '',
  },
  addDesktopReviewJob: {
    loading: false,
    data: {},
    error: '',
  },
  updateDesktopReviewJob: {
    loading: false,
    data: {},
    error: '',
  },
  updateDesktopReviewJobStatus: {
    loading: false,
    data: {},
    error: '',
  },
  products: {
    loading: false,
    data: [],
    error: ""
  }
};

export default (state = initialState, action) => {
  switch (action.type) {
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_FILTERS): {
      return {
        ...state,
        desktopReviewFilters: {
          ...state.desktopReviewFilters,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_FILTERS): {
      return {
        ...state,
        desktopReviewFilters: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_FILTERS): {
      return {
        ...state,
        desktopReviewFilters: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_JOBS): {
      return {
        ...state,
        desktopReviewJobs: {
          ...state.desktopReviewJobs,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_JOBS): {
      return {
        ...state,
        desktopReviewJobs: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_JOBS): {
      return {
        ...state,
        desktopReviewJobs: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_ALL_JOBS): {
      return {
        ...state,
        desktopReviewAllJobs: {
          ...state.desktopReviewAllJobs,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_ALL_JOBS): {
      return {
        ...state,
        desktopReviewAllJobs: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_ALL_JOBS): {
      return {
        ...state,
        desktopReviewAllJobs: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_PARTNER): {
      return {
        ...state,
        desktopReviewPartners: {
          ...state.desktopReviewPartners,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_PARTNER): {
      return {
        ...state,
        desktopReviewPartners: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_PARTNER): {
      return {
        ...state,
        desktopReviewPartners: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_JOB_DOCUMENTS): {
      return {
        ...state,
        desktopReviewJobDocuments: {
          loading: true,
          data: {},
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_JOB_DOCUMENTS): {
      return {
        ...state,
        desktopReviewJobDocuments: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_JOB_DOCUMENTS): {
      return {
        ...state,
        desktopReviewJobDocuments: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        desktopReviewJob: {
          loading: true,
          data: {},
          error: '',
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        desktopReviewJob: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        desktopReviewJob: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_JOB_TEST_PLANS): {
      return {
        ...state,
        desktopReviewJobTestPlans: {
          loading: true,
          ...state.desktopReviewJobTestPlans,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_JOB_TEST_PLANS): {
      return {
        ...state,
        desktopReviewJobTestPlans: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_JOB_TEST_PLANS): {
      return {
        ...state,
        desktopReviewJobTestPlans: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_JOB_SUMMARY): {
      return {
        ...state,
        desktopReviewJobSummary: {
          loading: true,
          ...state.desktopReviewJobSummary,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_JOB_SUMMARY): {
      return {
        ...state,
        desktopReviewJobSummary: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_JOB_SUMMARY): {
      return {
        ...state,
        desktopReviewJobSummary: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_SUPPLIERS_LIST): {
      return {
        ...state,
        suppliersList: {
          loading: true,
          ...state.suppliersList,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_SUPPLIERS_LIST): {
      return {
        ...state,
        suppliersList: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_SUPPLIERS_LIST): {
      return {
        ...state,
        suppliersList: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.ADD_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        addDesktopReviewJob: {
          ...state.addDesktopReviewJob,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.ADD_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        addDesktopReviewJob: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.ADD_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        addDesktopReviewJob: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.UPDATE_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        updateDesktopReviewJob: {
          ...state.updateDesktopReviewJob,
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.UPDATE_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        updateDesktopReviewJob: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.UPDATE_DESKTOP_REVIEW_JOB): {
      return {
        ...state,
        updateDesktopReviewJob: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.UPDATE_DESKTOP_REVIEW_JOB_STATUS): {
      return {
        ...state,
        updateDesktopReviewJobStatus: {
          data: {},
          error: '',
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.UPDATE_DESKTOP_REVIEW_JOB_STATUS): {
      return {
        ...state,
        updateDesktopReviewJobStatus: {
          loading: false,
          data: get(action, 'response.data') || {},
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.UPDATE_DESKTOP_REVIEW_JOB_STATUS): {
      return {
        ...state,
        updateDesktopReviewJobStatus: {
          loading: false,
          data: {},
          error: get(action, 'error'),
        },
      };
    }
    case asyncActionTypeRequest(types.GET_DESKTOP_REVIEW_PRODUCTS): {
      return {
        ...state,
        products: {
          data: [],
          error: '',
          loading: true,
        },
      };
    }
    case asyncActionTypeSuccess(types.GET_DESKTOP_REVIEW_PRODUCTS): {
      return {
        ...state,
        products: {
          loading: false,
          data: get(action, 'response.data') || [],
          error: '',
        },
      };
    }
    case asyncActionTypeFailure(types.GET_DESKTOP_REVIEW_PRODUCTS): {
      return {
        ...state,
        products: {
          loading: false,
          data: [],
          error: get(action, 'error'),
        },
      };
    }
    default:
      return state;
  }
};
